import { FormControl, Validators } from '@angular/forms';

export class RespostaManifestoDTO {

  idManifesto: FormControl;
  tipoManifesto: FormControl;
  responsavelRetorno: FormControl;
  responsavelRegistro: FormControl;
  dataRetorno: FormControl;
  respostaManifesto: FormControl;
  idStatus: FormControl;

  constructor() {

    this.idManifesto = new FormControl(null, [Validators.required]);
    this.tipoManifesto = new FormControl('', [Validators.required]);
    this.responsavelRetorno = new FormControl('', [Validators.required]);
    this.responsavelRegistro = new FormControl({ value: '', disabled: true }, [Validators.required]);
    this.dataRetorno = new FormControl(new Date().toISOString().substring(0, 10), [Validators.required]);
    this.respostaManifesto = new FormControl('', [Validators.required]);
    this.idStatus = new FormControl(1, [Validators.required, Validators.min(2)]);

  }

}
